import { MuiTelInput, MuiTelInputCountry } from "mui-tel-input";

import React from "react";

import { Box, FormControl, styled } from "@mui/material";

import { IgfdInputLabel } from "./Input";

const IgfdMuiTelInputBase = styled(MuiTelInput)(({ theme }) => ({
  /**
   * MuiTelInput does not provide docs to fully customize the input base to match our themed version.
   * Notable differences: on focus border is primary (not secondary), on hover boarder is black, border color is dark grey (not light grey)
   */
  "label + &": {
    marginTop: theme.spacing(2.5),
  },

  "& .MuiInputBase-input": {
    borderRadius: 8,
    position: "relative",
    border: "1px solid",
    backgroundColor: theme.palette.grey[50],
    borderColor: theme.palette.grey[50],
    fontFamily: theme.typography.body2.fontFamily,
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
    padding: "12px 16px",
  },
}));

// PhoneNumberInput
export type SupportedCountries = MuiTelInputCountry;

/** Formats phone number input */
export type PhoneNumberInputProps = {
  label: string;
  phoneNumber: string;
  onChange: (value: string) => void;
  fullWidth?: boolean;
  onlyCountries?: SupportedCountries[];
};

/** Defines how the entered phone number should be stored. */
export type StoredPhoneNumber = {
  e164PhoneNumber: string | null;
  formattedPhoneNumber: string | null;
};

export const e164FromFormattedPhoneNumber = (
  phoneNumber: string | null
): string | null => {
  return phoneNumber && phoneNumber.length > 0
    ? "+" + phoneNumber.replace(/\D/g, "")
    : null;
};

export const usePhoneNumberInput = ({
  storedPhoneNumber,
  setStoredPhoneNumber,
}: {
  storedPhoneNumber: StoredPhoneNumber;
  setStoredPhoneNumber: (value: StoredPhoneNumber) => void;
}) => {
  // When reading we read from the e164PhoneNumber
  // when saving, we get the formatted number from the PhoneNumberInput
  // we save both the e164PhoneNumber and the formattedPhoneNumber
  const handlePhoneNumberChange = (phoneNumber: string) =>
    setStoredPhoneNumber({
      e164PhoneNumber: e164FromFormattedPhoneNumber(phoneNumber),
      formattedPhoneNumber:
        phoneNumber && phoneNumber.length > 0 ? phoneNumber : null,
    });

  return {
    phoneNumber: storedPhoneNumber.e164PhoneNumber || "",
    onChange: handlePhoneNumberChange,
  };
};

export const PhoneNumberInput = ({
  label,
  phoneNumber,
  onChange,
  fullWidth,
  onlyCountries,
}: PhoneNumberInputProps) => {
  return (
    <Box sx={{ width: "100%" }}>
      <FormControl variant="standard" fullWidth={fullWidth}>
        <IgfdInputLabel label={label} />
        <IgfdMuiTelInputBase
          value={phoneNumber}
          onChange={onChange}
          onlyCountries={onlyCountries}
          defaultCountry={onlyCountries && onlyCountries[0]}
          disableDropdown={onlyCountries?.length === 1}
          forceCallingCode
        />
      </FormControl>
    </Box>
  );
};

// End PhoneNumberInput
